import { formatClockInText } from '@shared/clock';
import { glossInline } from '@shared/ptEn';

const TIPS = [
  {
    title: 'Cliffs and caves',
    body: 'Algar Seco, Benagil, and Marinha have unfenced drops. Stay on the boardwalk. Do not climb into sea caves from above.',
  },
  {
    title: 'Swell and rocks',
    body: 'Vale Covo and Vale Centeanes get a shore break. If the water is brown or dumping, swim at Carvoeiro village beach instead.',
  },
  {
    title: 'UV',
    body: 'Summer UV in the Algarve is routinely 8–10. Shade by 11:00. The Home weather card shows today’s index.',
  },
  {
    title: 'Heat',
    body: 'Inland (Silves, Monchique) runs hotter than the coast. Carry water on day trips. Cars parked in sun become ovens.',
  },
  {
    title: 'Driving',
    body: 'EN125 is the inland spine; N124/N125 junctions get busy. Watch for roundabouts and speed cameras into Lagoa.',
  },
  {
    title: 'Winter weather',
    body: 'November–March can bring Atlantic fronts, cliff-top wind, and short-lived heavy rain — not hurricanes. Roads can sheet.',
  },
];

export function SafetyPage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Beach & travel safety</h1>
        <p className="page-subtitle">Algarve weather and cliff tips — not Florida hurricane prep</p>
      </div>
      {TIPS.map((t) => (
        <div key={t.title} className="card">
          <h2>{t.title}</h2>
          <p>{glossInline(formatClockInText(t.body))}</p>
        </div>
      ))}
    </div>
  );
}
